module.exports = __webpack_public_path__ + "img/hcml_gallery11.047b15a4.jpg";